import { useEffect } from 'react';
import { useRouter } from 'next/router';
import settings from '@/settings';
import { getHtmlLang } from './html-lang';

/**
 * Keeps `<html lang>` on the store's regional tag after hydration.
 *
 * `_document` renders it, but Next's router writes the bare i18n locale
 * (`de`) back onto `<html>` after every route update — including the
 * query-only replace a dynamic page like the PDP does as it hydrates — so the
 * rendered page a crawler reads would lose the region again.
 */
export default function useHtmlLang() {
  const { locale } = useRouter();

  useEffect(() => {
    const lang = getHtmlLang(settings.store, locale);

    if (!lang) {
      return undefined;
    }

    const root = document.documentElement;

    const apply = () => {
      if (root.lang !== lang) {
        root.lang = lang;
      }
    };

    apply();

    const observer = new MutationObserver(apply);

    observer.observe(root, { attributes: true, attributeFilter: ['lang'] });

    return () => observer.disconnect();
  }, [locale]);
}
